import { render, staticRenderFns } from "./detailHeader.vue?vue&type=template&id=6cc5957a&scoped=true&"
import script from "./detailHeader.vue?vue&type=script&lang=js&"
export * from "./detailHeader.vue?vue&type=script&lang=js&"
import style0 from "./detailHeader.vue?vue&type=style&index=0&id=6cc5957a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc5957a",
  null
  
)

export default component.exports